// extracted by mini-css-extract-plugin
export default {"license-icons":"_2xrW9","licenseIcons":"_2xrW9"};